module.exports = __webpack_public_path__ + "slack-2-ac62631210b14ce56eac1a3d03d293d2.webp";